import { AbstractControl, ValidatorFn } from '@angular/forms';

export function arabicCharsOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isValid = !control.value || /^[\u0600-\u06FF\s]+$/.test(control.value);
    return isValid ? null : { arabicCharactersOnly: true };
  };
}
